// extracted by mini-css-extract-plugin
export default {"contentWrapper":"ResizeImage_contentWrapper__q52k4","modalContainer":"ResizeImage_modalContainer__IWmOV","button":"ResizeImage_button__3zxNy","input":"ResizeImage_input__9f0Zx"};